module.exports = __webpack_public_path__ + "static/media/CorrectorRegister_bg_mo.171a54d7.jpg";